const UnitUploadThesis = {
  tableConfig: {
    showCheckbox: true,
    minWidth: 1400
  },
  queryList: [
    {
      name: 'unitName',
      label: '学校名称',
      component: 'input'
    },
    {
      name: 'academyName',
      label: '院系名称',
      component: 'input'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confFirstSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'sendBatch',
      label: '批次号',
      component: 'input'
    },
    {
      name: 'currentState',
      label: '当前状态',
      component: 'select',
      componentAttr: {
        options: [{
          value: '6',
          label: '未指派专家'
        }, {
          value: '1',
          label: '待接收'
        }, {
          value: '2',
          label: '待送审'
        }, {
          value: '3',
          label: '待提交'
        }, {
          value: '4',
          label: '已评阅'
        }, {
          value: '5',
          label: '已退回'
        }]
      }
    }
  ],
  urlMap: {
    'select': '/school/schoolDegreeOffice/reviewList'
  },
  operList: [// 操作列表
    {
      name: 'batchMatch',
      label: '批量分配',
      show: true,
      action: {
        type: 'func',
        addr: 'recordSelectedAndJump',
        data: {
          name: 'batchSendThesisIds',
          addr: 'thesisManage/batchMatchExpert?from=unit'
        }
      }
    },
    {
      name: 'chooseReview',
      label: '选中送审',
      show: true,
      action: {
        type: 'request',
        method: 'post',
        data: '("{tableSelectionIds}").split(",")',
        addr: '/school/schoolDegreeOffice/sendSelected'
      }
    },
    {
      name: 'allReview',
      label: '全部送审',
      show: true,
      action: {
        type: 'request',
        addr: '/school/schoolDegreeOffice/sendAll',
        data: '{searchParam}'
      }
    },
    {
      name: 'generateLinks',
      label: '导出未分配评阅链接',
      show: true,
      action: {
        type: 'request',
        addr: '/exp/expReviewInfo/exportPaperInfo',
        data: '{searchParam}',
        nextAction: 'download'
      }
    },
    {
      name: 'resetLinks',
      label: '重置已退回评阅链接',
      show: true,
      action: {
        type: 'request',
        addr: '/school/schoolDegreeOffice/exportPaperInfo',
        data: '{searchParam}',
        refresh: true,
        nextAction: 'download'
      }
    },
    {
      name: 'download',
      label: '下载文件',
      show: false,
      action: {
        type: 'url',
        addr: '{data}'
      }
    }
  ],
  titles: [
    {
      name: 'expReviewId',
      key: true
    },
    {
      name: 'unitName',
      label: '学校名称'
    },
    {
      name: 'academyName',
      label: '所在学院'
    },
    {
      name: 'firstSubjectName',
      width: 95,
      label: '一级学科'
    },
    {
      name: 'secondSubjectName',
      width: 95,
      label: '二级学科'
    },
    {
      name: 'name',
      label: '已安排专家'
    },
    {
      name: 'currentState',
      width: 100,
      label: '专家状态'
    },
    {
      name: 'submitTime',
      label: '送审时间'
    },
    {
      name: 'sendBatch',
      label: '批次号'
    },
    {
      name: 'operation',
      label: '操作',
      width: 120,
      actionList: [
        {
          label: '分配',
          name: 'match',
          kind: 'primary', // error
          type: 'subRouter', // request, router, dialog, func
          addr: 'thesisManage/matchExpert?id={expReviewId}&from=unit'
        }
      ]
    }
  ]
}
export default UnitUploadThesis



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/unitUploadThesis2.js